const ls = {
  set(key: string, value: { [key: string]: string | number | boolean }) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return value;
    } catch (e) {
      return null;
    }
  },
  get(key: string) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || '{}');
    } catch (e) {
      return null;
    }
  },
  /*
   * ttl: ttl of the data in millsecond
   */
  setWithTTL(key: string, value: string, ttl = 0) {
    const data:any = {
      value,
      expiredAt: (new Date()).getTime() + ttl,
    };
    this.set(key, data);
  },

  /*
   * ttl: ttl of the data in millsecond
   */
  updateWithTTL(key: string, value: Date, ttl = 0) {
    const originData = this.getWithTTL(key) || {};
    const data:any = {
      value: {
        ...originData,
        ...value,
      },
      expiredAt: (new Date()).getTime() + ttl,
    };
    this.set(key, data);
  },

  getWithTTL(key: string) {
    const { value, expiredAt } = this.get(key) || {};
    if (value) {
      if ((new Date()).getTime() > expiredAt) {
        try {
          window.localStorage.removeItem(key);
        } catch (e) {
          // pass
        }
        return undefined;
      }
      return value;
    }
    return undefined;
  },
};

export default ls;
